import firebase from 'firebase/app';

//blueprint
import { Position,  Intent, Toaster } from "@blueprintjs/core";

const AppToaster = Toaster.create({
    className: "deleted-contact",
    position: Position.TOP,
});

const showToast = () => {
    AppToaster.show({ message: "Contact is deleted", intent: Intent.DANGER, timeout: 1000});
}

export const deleteContact = (id, profile) =>{
    firebase
    .firestore()
    .collection('organizations')
    .doc(profile.company)
    .collection('importedContacts')
    .doc(id)
    .delete()
    .then(()=>{
        showToast();
    })
}